import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard';

export const plugin = {
  use() {},

  unuse() {}
};
